import { forwardRef, HTMLAttributes } from "react"
import { styled, StyleProps, CSSFn, callCSSFn } from "../styles"

interface Props extends HTMLAttributes<HTMLDivElement> {
  size: `1` | `2` | `3` | `4`
  css?: CSSFn
}

type StyledContainerProps = Props & StyleProps

const getMaxWidth = (props: StyledContainerProps) => {
  switch (props.size) {
    case `1`:
      return `430px`
    case `2`:
      return `715px`
    case `3`:
      return `1145px`
    case `4`:
    default:
      return `none`
  }
}

const StyledContainer = styled.div<Props>((props: StyledContainerProps) => ({
  boxSizing: `border-box`,
  flexShrink: 0,
  marginLeft: `auto`,
  marginRight: `auto`,
  padding: props.theme.spacing(0, 5),
  maxWidth: getMaxWidth(props),
  ...callCSSFn(props),
}))

export const Container = forwardRef<HTMLDivElement, Props>((props, forwardedRef) => (
  <StyledContainer {...props} ref={forwardedRef} />
))

Container.defaultProps = {
  css: undefined,
}
